import {
  MOON_300,
  MOON_450,
  MOON_650,
  MOON_750,
} from '@wandb/weave/common/css/color.styles';

export const VEGA_DARK_CONFIG = {
  background: 'transparent',
  title: {color: MOON_300},
  axis: {
    labelColor: MOON_450,
    titleColor: MOON_300,
    gridColor: MOON_750,
    domainColor: MOON_650,
    tickColor: MOON_650,
  },
  legend: {
    labelColor: MOON_450,
    titleColor: MOON_300,
  },
  view: {stroke: MOON_750},
};
